import React from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { withTheme } from 'styled-components';
import styles from './products.module.scss';

import { Box, ButtonNew, Text, Grid } from 'components/Wrapped';

const products = [
  {
    id: 'product-1',
    title: 'Спот',
    description: 'Для торговли доступно более 700 криптовалют',
    linkUrl: '',
    bgImgUrl: 'assets/img/products/products_spot.png',
    isReady: true,
  },
  {
    id: 'product-2',
    title: 'Наличные',
    description: 'Повысьте свой опыт, торгуя фьючерсами',
    linkUrl: '',
    bgImgUrl: 'assets/img/products/products_cash.png',
    isReady: true,
  },
  {
    id: 'product-3',
    title: 'P2P',
    description: 'Лучшие в отрасли процентные ставки',
    linkUrl: '',
    bgImgUrl: 'assets/img/products/products_p2p.png',
    isReady: false,
  },
];

const Products = withNamespaces()(({ t: translate, size }) => {
  // const t = nestedTranslate(translate, 'sections');

  return (
    <Box
      pad={{
        horizontal: size === 'small' ? '16px' : '80px',
      }}
      className={styles.products}
    >
      <Box align="center" justify="center" pad="none" height="100%" width="100%">
        <Box
          pad={{
            vertical: '0px',
            horizontal: size === 'small' ? '0px' : '80px',
          }}
          direction="column"
        >
          <Box pad="none" direction="column">
            <Text
              color="white"
              size={size === 'small' ? '36px' : '56px'}
              weight="bold"
              margin={{ bottom: size === 'small' ? '39px' : '50px' }}
              textAlign="center"
              style={{ lineHeight: size === 'small' ? '36px' : '56px' }}
            >
              Наши основные продукты
            </Text>
            <Grid
              columns={{
                count: size === 'small' ? 1 : 3,
                size: 'auto',
              }}
              pad="none"
              gap="20px"
              style={{ maxWidth: '1280px' }}
            >
              {products.map((product) => (
                <Box
                  key={product.id}
                  background={{
                    color: 'background-6',
                    image: `url('${product.bgImgUrl}')`,
                    size: 'auto',
                    position: product.id === 'product-2' ? 'center 169%' : 'center 121%',
                  }}
                  pad={{
                    vertical: size === 'small' ? '35px' : '50px',
                    horizontal: size === 'small' ? '30px' : '40px',
                  }}
                  flex={{ grow: 1 }}
                  align="center"
                  height={size === 'small' ? '500px' : '560px'}
                  overflow="hidden"
                  style={{ position: 'relative', borderRadius: '10px' }}
                >
                  <Text color="white" size="30px" weight={500} margin={{ bottom: '10px' }} textAlign="center">
                    {product.title}
                  </Text>
                  <Text color="font-color-gray" size="18px" margin={{ bottom: '20px' }} textAlign="center">
                    {product.description}
                  </Text>
                  {product.isReady && <ButtonNew label="Узнать больше" theme="gray" buttonSize="large" width="180px" />}
                  {!product.isReady && (
                    <Box
                      background="#E6BD30"
                      direction="row"
                      pad={{ horizontal: '0px', vertical: '15px' }}
                      style={{
                        backdropFilter: 'blur(32px)',
                        position: 'absolute',
                        left: '50%',
                        bottom: 0,
                        transform: 'translateX(-50%)',
                      }}
                      width={{ max: 'auto' }}
                    >
                      {[1, 2, 3, 4].map((item) => (
                        <Text key={`soon-title-${item}`} color="#00080C" size="14px" weight={600} className={styles.soonTitle}>
                          Совсем скоро
                        </Text>
                      ))}
                    </Box>
                  )}
                </Box>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

const mapStateToProps = ({
  exchangeSettings: {
    settings: {
      seo: { reCaptchaKey },
    },
  },
}) => ({ reCaptchaKey });

export default withTheme(connect(mapStateToProps)(Products));
